import React from 'react';

const StartQuiz = () => {
    return (
        <div>
            in my test document
        </div>
    );
};

export default StartQuiz;